(function () {
  function reserveAspectRatio() {
    var selector = '.product-tabs__tab-item-content img[width][height], .rte img[width][height]';
    document.querySelectorAll(selector).forEach(function (img) {
      if (img.style.aspectRatio) return;
      if (img.closest('[data-flickity-carousel], .flickity-slider, product-media')) return;
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (w > 0 && h > 0) {
        img.style.aspectRatio = w + ' / ' + h;
      }
    });
  }
  reserveAspectRatio();
})();
